import { useMemo } from 'react';
import { useRouter } from 'next/router';
import {
  GOAL_UID,
  GOAL_NAME,
  IS_SUBSCRIPTION_ACTIVE,
  SUBSCRIPTION_DURATION,
  SUBSCRIPTION_END_DATE,
  LANGUAGE,
  NOT_APPLICABLE,
  SUBSCRIPTION_TYPE
} from '@events/segmentProps';
import { subscriptionTypes } from '@constants/index';
import { emptyObject } from '@constants/empty';
import { getMeLatestUserSubscriptions } from '@api/selectors/subscription';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { useSelectedGoalUID } from '@api/hooks/topology/useSelectedGoal';
import useTopology from '@api/hooks/topology/useTopology';

const useGoalEventProps = ({ goalUID = '' }) => {
  const {
    query: { goalUID: routeGoalUID }
  } = useRouter();
  const selectedGoalUID = useSelectedGoalUID();

  const currGoalUID = goalUID || routeGoalUID || selectedGoalUID;
  const { topology: goalData } = useTopology(currGoalUID);
  const { name: goalName, language } = goalData;
  const plusSubscriptions = useMyInfo(getMeLatestUserSubscriptions);

  const getSubscriptionType = (type) => {
    const entries = Object.entries(subscriptionTypes);
    const subscribedType = entries.find((entry) => entry[1] === type);
    return subscribedType ? subscribedType[0] : 'NA';
  };

  return useMemo(() => {
    const {
      subscription = emptyObject,
      expiredAt,
      timeRemaining
    } = plusSubscriptions[0] ?? {};
    const isSubscriptionActive = timeRemaining > 0;
    let goalSegmentData = {
      [GOAL_UID]: NOT_APPLICABLE,
      [GOAL_NAME]: NOT_APPLICABLE,
      [IS_SUBSCRIPTION_ACTIVE]: isSubscriptionActive,
      [SUBSCRIPTION_DURATION]: 'NA',
      [SUBSCRIPTION_END_DATE]: 'NA',
      [LANGUAGE]: language
    };
    if (currGoalUID) {
      goalSegmentData = {
        [GOAL_UID]: currGoalUID,
        [GOAL_NAME]: goalName,
        [IS_SUBSCRIPTION_ACTIVE]: isSubscriptionActive,
        [SUBSCRIPTION_DURATION]: NOT_APPLICABLE,
        [SUBSCRIPTION_END_DATE]: NOT_APPLICABLE,
        [LANGUAGE]: language,
        [SUBSCRIPTION_TYPE]: getSubscriptionType(subscription?.type)
      };
    }

    if (isSubscriptionActive) {
      goalSegmentData[SUBSCRIPTION_DURATION] = subscription.duration;
      goalSegmentData[SUBSCRIPTION_END_DATE] = expiredAt;
    }
    return goalSegmentData;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plusSubscriptions, goalUID, goalName]);
};

export default useGoalEventProps;
